<template>
  <div>

    <v-layout row wrap mx-3>

      <!-- <div class="mt-0 pt-0 mb-3"> -->
      <v-flex style="background-color:#292929; color: #ddd;" class="mb-3 row  px-3 py-2 elevation-0 xs12">
        <span class="font-weight-bold left subheading">Exhibition History  </span>
        <!-- <v-spacer></v-spacer> -->
        <!-- <v-btn v-if="!show_form" fab dark flat small icon class="right mr-2 mt-4" @click="show_form=true">
          <v-icon small dark>add</v-icon>
        </v-btn> -->
       
      </v-flex>

      <!-- <v-flex style="background-color:#292929; color: #ddd;" class="px-3 py-2 elevation-0 xs12">
        <h3 class="font-weight-bold body-2 xs12 flex">
          {{f_field.title}} 
          <v-menu offset-y class="right mb-1" v-if="!f_field.no_dynamic">
            <v-btn slot="activator" icon dark class="mt-0 mb-0">
              <v-icon class="mt-0 pt-0" dark>add</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile v-for="item in dynamic_field_list" :key="item.name" @click="add_field(item.name)">
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </h3> -->
        <!-- <v-divider color='black'></v-divider> -->
        <!-- </v-flex> -->

      <v-container class="xs12 pl-0 ml-0" fluid grid-list-xs v-if="this.exhibitions">
        
        <v-data-iterator v-if="view=='advanced' && this.advanced_years.length>0"
          :items="this.advanced_years"
          content-tag="v-layout" row wrap hide-actions
          item-key='id'
          item-value='id'
          >
          <v-flex slot="item" slot-scope="props" xs12 py-3>
            <h3 class="mx-2 pb-0">{{ props.item }}</h3>
            <v-spacer></v-spacer>
            <v-flex xs12 class="px-0 mx-0">
              <v-divider class="mx-1 pb-0 mb-3 black"></v-divider>
            </v-flex>            
            <!-- <h2 class="text-md-center">{{ props.item }}</h2> -->
            <v-flex v-for="e in exhibitions.filter(a => { return a.duration_start_year == props.item })" :key="e.id">
              <v-card class="elevation-0" color="grey lighten-3">
                <v-card-title class="ml-0 pl-2"><h4 class="ml-0 pl-0">{{e.show_type == 0 ? "Solo show" : "Group show" }}: {{ e.title }}</h4></v-card-title>
                <v-divider></v-divider>
                <v-list two-line>
                  <v-list-tile>
                    <v-list-tile-content>
                      {{ get_contact(e.institution_id) }}, {{ e.city }}, {{ e.country }} <br>
                      {{full_date(e)}} 
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </v-flex>
        </v-data-iterator>
      </v-container>

      
    </v-layout>

    <!-- <texts :artwork="artwork" :no_upload=true :add_text=false category="artwork_exhibition"></texts> -->
    <!-- <v-card-title class="headline ml-3 mt-3 mb-0"><h4>Exhibition History</h4></v-card-title> -->
    <v-card-text xs12>

      <v-layout row justify-center>
        <v-dialog v-model="dialog" max-width="540">
          <v-card>
            <v-card-title class="headline">Are you sure you want to delete this exhibition?</v-card-title>
            <v-card-text>
              This Exhibition will be deleted from all artworks.
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat="flat" @click="dialog = false">No</v-btn>
              <v-btn color="green darken-1" flat="flat" @click="deleteExhibition"> Yes</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <new-exhibition-history v-if="show_form" @show_form="show_form=$event"></new-exhibition-history>

      <!-- <v-flex class="right ml-3 mr-0 pr-0">
        <v-switch v-model="view" label="" color="grey" value="advanced" v-if="this.exhibitions.length>0"></v-switch>
      </v-flex> -->

      <h3 v-if="this.exhibitions.length==0" class='pl-4'>No Exhibitions for this artwork yet.</h3>

      <v-container class="xs12" fluid grid-list-md v-if="this.exhibitions">
        
        <!-- <v-data-iterator v-if="view=='advanced' && this.advanced_years.length>0"
          :items="this.advanced_years"
          content-tag="v-layout" row wrap hide-actions
          item-key='id'
          item-value='id'
          >
          <v-flex slot="item" slot-scope="props" xs12 py-3>
            <h2 class="text-md-center">{{ props.item }}</h2>
            <v-flex v-for="e in exhibitions.filter(a => { return a.duration_start_year == props.item })" :key="e.id">
              <v-card class="elevation-4" color="grey lighten-4">
                <v-card-title><h4>{{e.show_type == 0 ? "Solo show" : "Group show" }}: {{ e.title }}</h4></v-card-title>
                <v-divider></v-divider>
                <v-list two-line>
                  <v-list-tile>
                    <v-list-tile-content>
                      {{ e.institution }}, {{ e.city }}, {{ e.country }} <br>
                      {{full_date(e)}} </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </v-flex>
        </v-data-iterator> -->

        <!-- <v-data-iterator v-if="view!='advanced' && this.exhibitions.length>0"
          :items="this.exhibitions"
          content-tag="v-layout" row wrap hide-actions
          item-key='id'
          item-value='id'
          >
          <v-flex slot="item" slot-scope="props" xs12 sm12 md6 lg6>
            <v-card color="grey lighten-4">
              <v-card-title><h4>{{props.item.show_type == 0 ? "Solo show" : "Group show" }}: {{ props.item.title }}</h4></v-card-title>
              <v-divider></v-divider>
              <v-list >
                <v-list-tile>
                  <v-list-tile-content>{{ props.item.institution }}, {{ props.item.city }}, {{ props.item.country }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>{{full_date(props.item)}} </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content><p>{{props.item.admin_note}}</p> </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-card-actions v-if="c_user.delete_rights">
                <v-btn icon @click.stop="dialog = true"><v-icon>delete</v-icon></v-btn>
                <v-btn icon><v-icon>edit</v-icon></v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-data-iterator> -->

      </v-container>
    </v-card-text>

    <v-container class="my-0 mx-0 px-0 py-0" fluid v-if="[12,15,16].includes(this.artwork.ownership)">
      <!-- v-if="this.artwork.bibliography_details" -->
      <v-layout class="my-0 mx-2 px-0 py-0" row wrap>

        <v-flex style="background-color:#292929; color: #ddd;" class="mb-3 row  px-3 py-2 elevation-0 xs12">
          <span class="font-weight-bold left subheading">Exhibition History Vernon</span>
          <!-- <v-spacer></v-spacer> -->
          <!-- <v-btn v-if="!show_form" fab dark flat small icon class="right mr-2 mt-4" @click="show_form=true">
            <v-icon small dark>add</v-icon>
          </v-btn> -->
        
        </v-flex>
        
        <v-card class="my-2 mx-2 elevation-0" style="width:100%;">
          <!-- <v-card-title>
            <span class="headline">Exhibition History Vernon</span>
          </v-card-title> -->

          <v-card-text v-if="!edit_bio_dialog" v-html="this.artwork.exhibition_history != null ? this.artwork.exhibition_history : 'No exhibition history'"></v-card-text>
          
          <!-- <v-card-text v-if="edit_bio_dialog">
            <text-editor @input="exhibition_history=$event" :value="exhibition_history"></text-editor>
            <v-layout class="pl-3 pb-3 mt-2 justify-end">
              <v-spacer></v-spacer>
              <v-btn flat @click="edit_bio_dialog=false">cancel</v-btn>
              <v-btn dark @click="save_bio">save</v-btn>
            </v-layout>
          </v-card-text> -->
          
          <!-- <v-card-actions class="mr-0">
            <v-spacer></v-spacer>
            <v-btn @click="edit_bio()" small icon class="mr-3">
              <v-icon small>edit</v-icon>
            </v-btn>
            <v-btn small icon class="mr-3">
              <v-icon small>file_copy</v-icon>
            </v-btn>
            <v-btn @click="download_text(p)" small icon class="mr-3">
              <v-icon small color="black">mdi-download</v-icon>
            </v-btn>
            <v-btn @click="delete_text(p)" small icon v-if="c_user.delete_rights">
              <v-icon color="red" small>delete</v-icon>
            </v-btn>
          </v-card-actions> -->
        </v-card>

      </v-layout>
    </v-container>

  </div>
</template>

<script>
  import NewExhibitionHistory from '@/components/artworks/NewExhibitionHistory'
  import Texts from '@/components/artworks/Texts'
  export default {
    props: ['artwork'],
    data: () => ({
      view: 'advanced',
      edit_bio_dialog: false,
      show_form: false,
      show: true,
      dialog: false
      // exhibitions: this.exhibitions2
    }),
    // created () {
    //   this.reset_view()
    // },
    methods: {
      deleteExhibition (e) {
        // var index = exhibition_artworks.indexOf(e);
        // console.log('index = ' + index)
        // exhibition_artworks.splice(index,1)
        this.$store.dispatch('deleteExhibition',e)
        this.dialog = false
      },
      // reset_view () {
      //   var ee = this.store_e
      //   this.exhibitions = this.exhibitions2
      //   // console.log('reset_view')
      //   // console.log(this.exhibitions2)
      // }
      start_date (e) {
        var out = e.duration_start_year
        var options = { day: 'numeric', month: 'long', year: 'numeric'};
        if (e.duration_start_month && e.duration_start_day) {
          if (e.duration_start_month) {
            out = out + '-' + e.duration_start_month.toString().padStart(2, "0")
          }
          if (e.duration_start_day) {
            out = out + '-' + e.duration_start_day.toString().padStart(2, "0")
          }
          out = new Date(out).toLocaleDateString("en-US", options)
        }
        return out
      },
      end_date (e) {
        var out = e.duration_end_year
        var options = { day: 'numeric', month: 'long', year: 'numeric'};
        if (e.duration_end_month && e.duration_end_day) {
          if (e.duration_end_month) {
            out = out + '-' + e.duration_end_month.toString().padStart(2, "0")
            // out = e.duration_end_month.toLocaleDateString("en-US", options)
          }
          if (e.duration_end_day) {
            out = out + '-' + e.duration_end_day.toString().padStart(2, "0")
          }
          out = new Date(out).toLocaleDateString("en-US", options)
        }
        return out
      },
      full_date (e){
        var out = this.start_date(e)
        if (this.end_date(e)) {
          out = out + ' - ' + this.end_date(e)
        }
        return out
      }
    },
    computed: {
      advanced_years () {
        return this.exhibitions.map(a => a = a.duration_start_year).sort(function(a, b) {
          return a - b;
        }).reverse().filter(function (value, index, self) {
          return self.indexOf(value) === index;
        })},
      store_e () {
        // console.log('store_e')
        return this.$store.state.exhibitions
      },
      exhibitions () {
        return this.artwork.exhibitions.filter(e => e.category != 'commissions')
        // console.log('exa')
      //   return this.store_e.filter(t => {
      //     return t.artworks.map(a => a = a.artwork_id).includes(this.artwork.id)
      // }).sort(function(a, b) {
      //   return a.duration_start - b.duration_start;
      // })
    }
  },
  components: {NewExhibitionHistory,Texts}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/artworks/ExhibitionHistory.vue